module.exports = __webpack_public_path__ + "img/ic_member.0d24e69f.png";